<template>
  <div class="bullets">
    <div v-if="title" class="font-bold text-text text-20 pb-7">
      {{ $t(title) }}
    </div>
    <div class="bullet-list">
      <span
        v-for="(d, index) in data"
        :key="`data-${index}`"
        class="bullet"
        :class="{ active: d.id ? d.label == value : d == value}"
        @click="$emit('select', d)"
        >
        <div v-if="d.id" class="flex">
          <img class="pr-2" :src="`${$store.state.appUrl}/img/pwa/${d.icon}${d.label == value ? '-active' : ''}.svg`" />
          <span> {{d.label}} </span>
        </div>
        <div v-else>
          <span>{{d}}</span>
          <span v-if="title === 'Discount'">%</span>
        </div>
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      data: {
        type: Array,
        default: () => []
      },
      value: {
        type: [Number, String],
        default: 0
      }
    }
  }
</script>
